import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import './Product_Slider.css'

import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { data } from 'autoprefixer';

const Detail_Product_Slider = ({image}) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  console.log(image)
  return (
    <>
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }}
        loop={true}
        spaceBetween={10}
        // navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
         {image.map((data,index)=>(
        <SwiperSlide>
          <img src={data} className='preview' />
        </SwiperSlide>
       ))}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={true}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper1"
      >
        {image.map((data,index)=>(
        <SwiperSlide>
          <img src={data}  />
        </SwiperSlide>
       ))}
      </Swiper>
    </>
  )
}

export default Detail_Product_Slider
